import AiGenerativeTextIcon from '@atlaskit/icon-lab/core/ai-generative-text';
import * as React from 'react';

export function SvgAutoDraft() {
  return <AiGenerativeTextIcon label="" testId="ads-refreshed-icon" />;
}
